import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

interface Tenant {
  id: string;
  ownerId: string;
  name: string;
  email: string;
  status: 'active' | 'inactive' | 'suspended';
  verified: boolean;
  shared: boolean;
  ownerEmail: string;
  createdAt: string;
  updatedAt: string;
}



export const useTenants = () => {
  const apiClient = useApiClient();
  
  return useQuery({
    queryKey: ['tenants'],
    queryFn: async (): Promise<Tenant[]> => {
      const response = await apiClient.get('/tenants');

      if (!response.ok) {
        throw new Error('Failed to fetch tenants');
      }

      const data = await response.json();
      return data.tenants || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};